module.exports = __webpack_public_path__ + "assets/icon-orderType-fence.3efe33a3.svg";